import {
  CheckCircleOutlined,
  ClockCircleOutlined,
  CloseCircleOutlined,
  PlayCircleOutlined,
  QuestionCircleOutlined,
} from '@ant-design/icons';
import styled from '@emotion/styled';
import { Modal, Popconfirm, Progress, Table, Tooltip } from 'antd';
import useShopeeAuthShops from 'hooks/business/authShops/useShopeeAuthShops';
import { useMemo } from 'react';
import { useTranslate } from '@tolgee/react';
import Tips from './Tips';

const Wrap = styled.div`
  & .ant-modal-mask,
  & .ant-modal-wrap {
    top: 40px;
    left: 205px;
  }
`;
const Title = styled.div`
  margin-top: 16px;
  font-size: 16px;
  font-weight: 500;
`;
const Line = styled.div`
  height: 20px;
  font-size: 14px;
  color: #515359;
  margin-top: 5px;

  & > .anticon {
    margin-right: 5px;
  }
`;
const AbortAuth = styled.div`
  display: inline-block;
  margin-top: 30px;
  font-size: 14px;
  color: #88898c;
  cursor: pointer;

  & > .anticon {
    margin-left: 5px;
  }
`;

const MultipleAuthProgressModal = () => {
  const {
    terminateAuth,
    isMultipleAuthProgressPending,
    authProgressInfo,
    showAuthErrorTips,
    isQuickMode,
  } = useShopeeAuthShops();
  const { t } = useTranslate();

  const columns = useMemo(
    () => [
      {
        title: '帐号',
        dataIndex: 'account',
      },
      {
        title: '失败原因',
        dataIndex: 'reason',
      },
    ],
    [],
  );

  return (
    <Wrap>
      <Modal
        visible={isMultipleAuthProgressPending}
        footer={null}
        getContainer={false}
        closable={false}
        mask
      >
        {isQuickMode ? (
          <Tips>{t('ViewShops.shopee.auth.process.tips.quick.info')}</Tips>
        ) : (
          <Tips showAuthError={showAuthErrorTips} />
        )}
        <Title>
          {t('ViewShops.shopee.auth.progress.account.auth.total.title', {
            x: authProgressInfo?.allAccounts ?? 0,
          })}
        </Title>
        <Progress percent={authProgressInfo?.progress || 0} />
        <Line>
          <ClockCircleOutlined style={{ color: 'var(--ant-warning-color)' }} />
          {t('ViewShops.shopee.auth.progress.account.wait.title', {
            x: authProgressInfo?.waitAuthAccounts ?? 0,
          })}
          {t('ViewShops.shopee.auth.progress.account.wait.retry.title', {
            x: authProgressInfo?.waitRetryAccounts ?? 0,
          })}
        </Line>
        <Line>
          <CheckCircleOutlined style={{ color: 'var(--ant-success-color)' }} />
          {t('ViewShops.shopee.auth.progress.account.success.title', {
            x: authProgressInfo?.authSuccessAccounts ?? 0,
          })}
        </Line>
        {isQuickMode ? (
          <Line>
            <PlayCircleOutlined style={{ color: 'var(--ant-info-color)' }} />
            {t('ViewShops.shopee.auth.progress.account.quick.skip.title', {
              x: authProgressInfo?.quickModeAccounts ?? 0,
            })}
          </Line>
        ) : null}
        <Line>
          <CloseCircleOutlined style={{ color: 'var(--ant-error-color)' }} />
          {t('ViewShops.shopee.auth.progress.account.fail.title', {
            x: authProgressInfo?.authFailAccounts ?? 0,
          })}
        </Line>
        <Table
          size="small"
          style={{ marginTop: 10 }}
          columns={columns}
          dataSource={authProgressInfo?.lastFailedList}
          pagination={false}
          scroll={{ y: 180 }}
        />
        <Popconfirm
          title={t('ViewShops.shopee.auth.progress.terminal.title')}
          onConfirm={() => {
            terminateAuth();
          }}
        >
          <AbortAuth>
            {t('ViewShops.shopee.auth.progress.terminal.btn.text')}
            <Tooltip title={t('ViewShops.shopee.auth.progress.terminal.tips')}>
              <QuestionCircleOutlined />
            </Tooltip>
          </AbortAuth>
        </Popconfirm>
      </Modal>
    </Wrap>
  );
};

export default MultipleAuthProgressModal;
